<template>
    <div v-if="company.id">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Confirmar dados da Empresa</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10 offset-md-1">
                                <div class="row">
                                    <div class="col-md-12 centered">
                                        <h3>Bem-vindo(a) ao Pesquisa!</h3>
                                        <h5>Para podermos começar, confirme os dados da sua empresa:</h5>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <label>Nome Corporativo</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.corporate_name"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label>Nome Fantasia</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.fantasy_name"
                                        />
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <label>CNPJ</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.cnpj"
                                            v-mask="'##.###.###/####-##'"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label>Endereço</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.adress"
                                        />
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <label>E-mail</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.email"
                                        />
                                    </div>
                                    <div class="col-md-6">
                                        <label>CEP</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="company.cep"
                                            v-mask="'##.###-###'"
                                        />
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-md-12">
                                        <button
                                            class="btn btn-normal float-right"
                                            @click="confirm"
                                        >Confirmar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            company: {
                corporate_name: "",
                fantasy_name: "",
                cnpj: "",
                adress: "",
                email: "",
                cep: ""
            }
        };
    },
    methods: {
        makeFormData() {
            const fd = new FormData();

            fd.append("corporate_name", this.company.corporate_name);
            fd.append("fantasy_name", this.company.fantasy_name);
            fd.append("cnpj", this.company.cnpj);
            fd.append("adress", this.company.adress);
            fd.append("email", this.company.email);
            fd.append("customer_id", this.company.customer_id);
            fd.append("cep", this.company.cep);
            fd.append("id", this.company.id);

            fd.append("_method", "PUT");

            return fd;
        },
        confirm() {
            const self = this;
            const api = self.$store.state.api + "companies/" + self.company.id;

            const fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then(response => {
                    const apiStep =
                        self.$store.state.api +
                        "researchfirststeps/stepCompleted";
                    self.$http
                        .post(apiStep, {
                            step: "confirmCompanyData"
                        })
                        .then(response => {
                            self.$message(
                                "Sucesso",
                                "Dados confirmados com sucesso",
                                "success"
                            );
                            self.$router.push("/firstSteps/importation");
                        })
                        .catch(error => {
                            self.$message("Erro", error.response.data, "error");
                        });
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getMyCompany() {
            const self = this;
            const api = self.$store.state.api + "companies/getMyCompany";
            self.$http
                .get(api)
                .then(response => {
                    self.company = response.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted() {
        this.getMyCompany();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/FirstSteps/ConfirmCompanyData.vue